import { Suspense, useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { useVisualViewportHeight } from '@leanpay/hooks'
import { A11yAnnouncer, LoadingIndicator } from '@leanpay/ui'

import { useAppStore } from './app-store'
import CreditHeader from './components/credit-header/credit-header'
import { CreditRoute, isMarketRom, isMarketSlo } from 'library/constants'
import { lazyWithRetry } from 'library/lazy-with-retry'
import { handleCreditProgress } from 'library/utils'

const MainAppROM = lazyWithRetry(() => import('./credit-markets/rom/main-app-rom'))
const MainAppSLO = lazyWithRetry(() => import('./credit-markets/slo/main-app-slo'))

const CANCEL_ICON_EXCLUDED_ROUTES: string[] = [
    '/',
    `/${CreditRoute.CreditSuccess}`,
    `/${CreditRoute.CreditError}`,
    `/${CreditRoute.CreditRejection}`,
    `/${CreditRoute.ValidateOffer}`,
    `/${CreditRoute.ScoringDecision}`,
    `/${CreditRoute.ValidationCheck}`,
]

const MainLayout = () => {
    const location = useLocation()
    const { isAuthenticated, progress, setProgress } = useAppStore()

    useVisualViewportHeight()

    useEffect(() => {
        handleCreditProgress(location.pathname, setProgress)
    }, [location.pathname, setProgress])

    const showCancelIcon =
        isAuthenticated && !CANCEL_ICON_EXCLUDED_ROUTES.includes(location.pathname)

    const renderApp = () => {
        if (isMarketSlo) return <MainAppSLO />
        if (isMarketRom) return <MainAppROM />

        throw Error('Credit: Unsupported market')
    }

    return (
        <div className="main-layout flex-1 self-center flex flex-col items-center overflow-y-auto overscroll-none min-[900px]:scroll-smooth max-w-[840px] w-full bg-lp-grey2 rounded-lg min-[900px]:max-h-[95vh] min-[900px]:my-auto max-[899px]:rounded-none max-[899px]:max-w-full max-[899px]:h-full max-[899px]:pb-30">
            <A11yAnnouncer />
            <CreditHeader progress={progress} showCancelIcon={showCancelIcon}>
                <Suspense fallback={<LoadingIndicator />}>{renderApp()}</Suspense>
            </CreditHeader>
        </div>
    )
}

export default MainLayout
